import React from "react";

const STACK_SIZE = 2;

export default function PersonStack({
  stack,
  currentIndex,
  currentFounder,
  swipeDir,
  isAnimating,
  isSpeaking,
  speechBubble,
  bazookaPhase,
  saberPhase,
  vanPhase,
  garryPhase,
  glockPhase,
  marcPhase,
  claudePhase,
  advance,
  handleSwipe,
}) {
  return (
    <div className="stack-container">
      {stack.map(({ founder, depth }) => {
        const isFront = depth === 0;
        const swipeClass = isFront
          ? swipeDir === "right"
            ? "swipe-right"
            : swipeDir === "left"
            ? "swipe-left"
            : bazookaPhase === "explode" || bazookaPhase === "lower"
            ? "bazooka-hit"
            : saberPhase === "cut" || saberPhase === "lower"
            ? "saber-cut"
            : saberPhase === "slash"
            ? "saber-slashed"
            : vanPhase === "grab"
            ? "van-grabbed"
            : vanPhase === "close" || vanPhase === "drive"
            ? "van-grabbed-gone"
            : garryPhase === "lead" || garryPhase === "exit"
            ? "garry-follow"
            : glockPhase === "shoot"
            ? "glock-shot"
            : glockPhase === "lower"
            ? "glock-dead"
            : marcPhase === "grab" || marcPhase === "exit"
            ? "marc-dragged"
            : claudePhase === "run"
            ? "claude-run-away"
            : ""
          : "";

        const scale = depth === 0 ? 1 : 0.55;
        const zIndex = STACK_SIZE - depth;
        const opacity = depth === 0 ? 1 : 0;

        return (
          <div
            key={founder.id + "-" + (currentIndex + depth)}
            className={`person-card ${swipeClass} ${!swipeClass && !isAnimating && isFront ? `fade-in ${isSpeaking ? 'talking' : 'idle'}` : ''}`}
            onAnimationEnd={isFront && (swipeClass === "swipe-right" || swipeClass === "swipe-left") ? advance : undefined}
            style={{
              zIndex,
              transform: isFront && (swipeClass || !isAnimating) ? undefined : `scale(${scale})`,
              opacity,
            }}
          >
            <img
              src={founder.photoUrl}
              alt={founder.name}
              className="person-img"
              draggable={false}
            />
          </div>
        );
      })}

      {/* Glock bullet holes */}
      {glockPhase === "shoot" && (
        <div className="bullet-holes-container">
          {[
            { left: '45%', top: '35%' },
            { left: '52%', top: '45%' },
            { left: '42%', top: '55%' },
            { left: '55%', top: '40%' },
            { left: '48%', top: '50%' },
            { left: '50%', top: '60%' },
          ].map((pos, i) => (
            <React.Fragment key={i}>
              <div
                className="bullet-hole"
                style={{
                  left: pos.left,
                  top: pos.top,
                  animationDelay: `${i * 0.2}s`,
                }}
              />
              {Array.from({ length: 8 }).map((_, j) => (
                <div
                  key={`blood-${i}-${j}`}
                  className="blood-particle"
                  style={{
                    left: pos.left,
                    top: pos.top,
                    animationDelay: `${i * 0.2}s`,
                    '--blood-angle': `${j * 45}deg`,
                    '--blood-dist': `${30 + Math.random() * 50}px`,
                    '--blood-size': `${3 + Math.random() * 5}px`,
                  }}
                />
              ))}
            </React.Fragment>
          ))}
          {Array.from({ length: 6 }).map((_, i) => (
            <div
              key={`flash-${i}`}
              className="muzzle-flash"
              style={{ animationDelay: `${i * 0.2}s` }}
            />
          ))}
        </div>
      )}

      {/* Saber cut halves */}
      {(saberPhase === "cut" || saberPhase === "lower") && (
        <>
          <div className="saber-cut-left">
            <img src={currentFounder.photoUrl} alt="" className="saber-cut-half-img" draggable={false} />
          </div>
          <div className="saber-cut-right">
            <img src={currentFounder.photoUrl} alt="" className="saber-cut-half-img" draggable={false} />
          </div>
        </>
      )}

      {/* Fire overlay */}
      {swipeDir === "left" && isAnimating && (
        <div className="burn-fire-container">
          <img src="/flame.png" alt="" className="burn-flame-img" draggable={false} />
          <img
            src="/flame.png"
            alt=""
            className="burn-flame-img"
            style={{ width: "90%", animationDelay: "0.85s", filter: "brightness(1.4) hue-rotate(-10deg)" }}
            draggable={false}
          />
          {Array.from({ length: 12 }).map((_, i) => (
            <div
              key={i}
              className="burn-ember"
              style={{
                left: `${10 + Math.random() * 80}%`,
                bottom: `${10 + Math.random() * 30}%`,
                animationDelay: `${0.9 + Math.random() * 0.6}s`,
                "--drift": `${(Math.random() - 0.5) * 80}px`,
                background: ["#ff6600", "#ffaa00", "#ff3300", "#ffdd00"][i % 4],
              }}
            />
          ))}
        </div>
      )}

      {/* Dialogue Box */}
      {speechBubble && !isAnimating && (
        <div className="dialogue-box" key={speechBubble}>
          <span className="dialogue-name">{currentFounder.name}:</span>
          <span className="dialogue-text">{speechBubble}</span>
          <span className="dialogue-arrow">▼</span>
        </div>
      )}

      {/* Action Buttons */}
      <button
        className="action-btn reject-btn"
        onClick={() => handleSwipe("left")}
        disabled={isAnimating}
        aria-label="Reject"
      >
        <img src="/no.png" alt="No" className="action-btn-img" draggable={false} />
      </button>
      <button
        className="action-btn like-btn"
        onClick={() => handleSwipe("right")}
        disabled={isAnimating}
        aria-label="Like"
      >
        <img src="/yes.png" alt="Yes" className="action-btn-img" draggable={false} />
      </button>
    </div>
  );
}
